<div class="row h-100 m-0">
    <div class="col-md-6 offset-md-3 col-sm-10 offset-sm-1 h-100 d-flex">
      <form #f="ngForm" (ngSubmit)="onSubmit(f)" class="align-self-center bg-white border rounded-lg p-5 w-100">
        <section class="bl-header pb-2 mb-2 d-flex">
          <h2 class="flex-grow-0">
            Login
          </h2>
        </section>
        <mat-form-field class="w-100" appearance="outline">
          <mat-label>Email</mat-label>
          <input type="email" name="loginEmail" placeholder="Ex. pat@example.com"
                 matInput ngModel email required>
        </mat-form-field>
        <mat-form-field class="w-100" appearance="outline">
          <input type="password" name="loginPassword"
                 matInput ngModel required>
        </mat-form-field>
        <div *ngIf="isLoginError===true" class="text-red-600 text-sm mt-1">
          Error logging in. Please check your credentials and try again.
        </div>
        <div class="w-100 d-flex flex-row-reverse pt-2 pb-2">
          <button class="flex justify-content-center items-center drop-shadow-md shadow-fuchsia-950 bg-fuchsia-800 text-white px-4 py-2 rounded-pill border-b-4 border-fuchsia-950">
            <div *ngIf="isLoading" class="spinner-border w-4 h-4 text-orange-300 mr-2" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
            <span class="">Login</span>
          </button>
        </div>
        <div class="text-center">
          <a href="" class="">Forgot your password?</a>
          <span class="text-sm px-2">or</span>
          <a routerLink="/register" class="">Create a new account</a>
        </div>
      </form>
    </div>
  </div>
